import {HttpClient} from "@angular/common/http";
import {StandalonePctConfigService} from "./standalone-pct-config.service";
import {RemotePctConfigService} from "./remote-pct-config.service";
import {StandaloneModeService} from "../../standalone-mode.service";
import {SqliteRemConfigRepository} from "../../sqllite/repositories/rem-configs/sqlite-pct-config.repository";
import {ParametersDatabase} from "../../sqllite/databases/parameters.database";

export const pctConfigServiceFactory = (standaloneModeService: StandaloneModeService, parametersDatabase: ParametersDatabase, httpClient: HttpClient) => {
    return standaloneModeService.isOffline() ? new StandalonePctConfigService(new SqliteRemConfigRepository(parametersDatabase)) : new RemotePctConfigService(httpClient);
}